export default "__VITE_PUBLIC_ASSET__108df80e__"